.leftPanel {
    display: flex;
    flex: 0 0 45%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
    padding: 4rem 3rem;

    .logoSection {
        display: flex;
        margin: 5rem 0;

        .activityIcon {
            margin-bottom: 2rem;
            width: 80px;
            height: 80px;
            color: #4169e1;
        }
        .systemTitle {
            margin-bottom: 0.5rem;
            color: #2c3e50;
            font-weight: 700;
            font-size: 2.5rem;
        }
        .systemSubtitle {
            margin: 0;
            color: #7f8c8d;
            font-size: 1.1rem;
        }
    }
    .statusSection {
        display: flex;
        gap: 1rem;
        list-style: none;

        .statusItem {
            display: flex;
            align-items: center;
            margin-bottom: 1rem;
            font-size: 1rem;

            .statusIcon {
                margin-right: 0.75rem;
                color: #27ae60;
                font-size: 1.25rem;
            }
        }
    }

    .copyright {
        color: #95a5a6;
        font-size: 0.9rem;
        text-align: center;
    }
}

.rightPanel {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    background: white;
    padding: 2rem;

    .loginCard {
        width: 100%;
        max-width: 480px;
    }

    .header {
        border-radius: 12px 12px 0 0;
        background: linear-gradient(135deg, #4169e1 0%, #6366f1 100%);
        padding: 3rem 2.5rem;
        color: white;
        text-align: center;

        .shieldIcon {
            margin-bottom: 1rem;
            font-size: 3.5rem;
        }

        h4 {
            margin: 0 0 0.5rem 0;
            font-weight: 600;
            font-size: 1.75rem;
        }

        p {
            opacity: 0.95;
            margin: 0;
            font-size: 1rem;
        }
    }

    .formBody {
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
        border-radius: 0 0 12px 12px;
        background: white;
        padding: 2.5rem;
    }
}

.formGroup {
    margin-bottom: 1.5rem;

    label {
        display: block;
        margin-bottom: 0.5rem;
        color: #333;
        font-weight: 500;
        font-size: 0.95rem;
    }

    .inputWrapper {
        position: relative;

        .inputIcon {
            position: absolute;
            top: 50%;
            left: 1rem;
            transform: translateY(-50%);
            color: #999;
            font-size: 1.1rem;
        }

        input {
            transition: all 0.2s;
            border: 1px solid #e0e0e0;
            border-radius: 8px;
            background-color: #f8f9fa;
            padding: 0.85rem 1rem 0.85rem 3rem;
            width: 100%;
            font-size: 0.95rem;

            &:focus {
                outline: none;
                box-shadow: 0 0 0 3px rgba(65, 105, 225, 0.1);
                border-color: #4169e1;
                background-color: white;
            }

            &::placeholder {
                color: #999;
            }
        }
    }
}

.checkboxGroup {
    margin-bottom: 1.5rem;

    label {
        display: flex;
        align-items: center;
        cursor: pointer;
        user-select: none;

        input[type='checkbox'] {
            cursor: pointer;
            margin-right: 0.5rem;
            width: 18px;
            height: 18px;
        }

        span {
            color: #666;
            font-size: 0.9rem;
        }
    }
}

.loginButton {
    transition: all 0.3s;
    cursor: pointer;
    border: none;
    border-radius: 8px;
    background: linear-gradient(135deg, #4169e1 0%, #6366f1 100%);
    padding: 0.85rem;
    width: 100%;
    color: white;
    font-weight: 600;
    font-size: 1rem;

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(65, 105, 225, 0.3);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}
